import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class AuthService {
  private _isMaster = new BehaviorSubject<string>('');
  private _isSubuser = new BehaviorSubject<boolean>(false);
  private _subUserRole = new BehaviorSubject<number>(0);     // get subuser role ( rbac feature )

  private _roleMenu_Map = new BehaviorSubject( [] ); 
  private _roleSubMenu_Map = new BehaviorSubject( [] ); 
  private _rolePageTabs_Map = new BehaviorSubject( [] ); 


  isMaster$ = this._isMaster.asObservable();
  isSubuser$ = this._isSubuser.asObservable();
  subUserRole$ = this._subUserRole.asObservable();

  roleMenu_Map$ = this._roleMenu_Map.asObservable();
  roleSubMenu_Map$ = this._roleSubMenu_Map.asObservable();
  rolePageTabs_Map$ = this._rolePageTabs_Map.asObservable();

  constructor() {
  }
  
  setMasterState(val) {
    this._isMaster.next(val);
  }

  setSubUserState(val) {
    console.log( " set subuser val ", val );
    sessionStorage.setItem('isSubUser',val?'1':'0');
    this._isSubuser.next(val);
  }

  setSubUserRole( val ) {
    console.log( " set subuser role ", val );
     this._subUserRole.next(val);
  }

  setSubuserRoleAccess( val, type : number ){    // type : 1 - for menu, 2 - submenu, 3 - page tabs
      
      if( type == 1 ){ 
        this._roleMenu_Map.next( val );
      }
      else if( type == 2 ){
        this._roleSubMenu_Map.next( val );
      }
      else if( type == 3){
        this._rolePageTabs_Map.next( val );
      }
  }




}
